import { jsx } from "react/jsx-runtime";
import { memo, forwardRef } from "react";
import { Button } from "./Forms/Button/Button.js";
const SaveButton = memo(
  forwardRef(
    ({
      distinction,
      flow,
      isDirty,
      isPrimary = true,
      labelSave,
      labelSaved,
      scheme,
      size,
      ...rest
    }, ref) => {
      return /* @__PURE__ */ jsx(
        Button,
        {
          ref,
          size: size ?? "large",
          flow,
          scheme,
          distinction: rest.disabled ? "seamless" : isPrimary ? "primary" : distinction,
          ...rest,
          children: isDirty ? labelSave ?? "Save" : labelSaved ?? "Save"
        }
      );
    }
  )
);
SaveButton.displayName = "SaveButton";
export {
  SaveButton
};
//# sourceMappingURL=SaveButton.js.map
